Vue.component('ack-about-us', {
    delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
    template: '#ack-about-us',
    mixins: [languageMixins],
    created() {
      
    },
    mounted() {
      appLog.log('ack-about-us mounted')
      this.setPageIsLoading(false)
    },
    created() {

    },
    props:{
      // dataIn: {
      //   type: Object,
      //   required: true
      // }

    },
    computed: {
      //...Vuex.mapGetters('sliders', ['slidersLists']),
      //...Vuex.mapGetters('articles', ['articlesArray']),
      isMobile(){
        return this.$parent.isMobile
      },
    },
    data() {
      return {
        pageId: 'about-us-page',
        aboutUsInfo:{
            ceo_message_section: {
                title: 'about_us.ceo_message.title',
                message: 'about_us.ceo_message.message',
                name: 'about_us.ceo_message.name',
            },
            testimonials_section: {
                testimonial_items: [
                  { id: 1, name: 'about_us.testimonial_section.testimonial_items.testimonial_one.name', title: 'about_us.testimonial_section.testimonial_items.testimonial_one.title', quote: 'about_us.testimonial_section.testimonial_items.testimonial_one.description', img_src: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/stivetiang.jpg?v=1646636670', altText: 'First slide' },
                  { id: 2, name: 'about_us.testimonial_section.testimonial_items.testimonial_two.name', title: 'about_us.testimonial_section.testimonial_items.testimonial_two.title', quote: 'about_us.testimonial_section.testimonial_items.testimonial_two.description', img_src: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/arunachalam_jpg.jpg?v=1646636669', altText: 'Second slide' },
                  { id: 3, name: 'about_us.testimonial_section.testimonial_items.testimonial_three.name',title: 'about_us.testimonial_section.testimonial_items.testimonial_three.title', quote: 'about_us.testimonial_section.testimonial_items.testimonial_three.description', img_src: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/luisdebellis.jpg?v=1646636669', altText: 'Third slide' },
                  { id: 4, name: 'about_us.testimonial_section.testimonial_items.testimonial_four.name',title: 'about_us.testimonial_section.testimonial_items.testimonial_four.title', quote: 'about_us.testimonial_section.testimonial_items.testimonial_four.description', img_src: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/adamnulty.jpg?v=1646636669', altText: 'fourth slide' },
                  { id: 5, name: 'about_us.testimonial_section.testimonial_items.testimonial_five.name',title: 'about_us.testimonial_section.testimonial_items.testimonial_five.title', quote: 'about_us.testimonial_section.testimonial_items.testimonial_five.description', img_src: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/tomshao.jpg?v=1646636669', altText: 'fifth slide' },
                ],
              },
        }
      }
    },
    methods: {
      ...Vuex.mapActions(['setPageIsLoading'])
      //...Vuex.mapActions('sliders', ['getSlideList'])




    },
    beforeDestroy() {

    },
    watch: {

      data1: {
        handler() {



        },
        deep: false
      }
    }
  })